import React from 'react';
import { mapModifiers, ModifierProp } from 'libs/component';

export interface OptionItemProps {
  children?: React.ReactNode;
  modifiers?: ModifierProp<'active'>;
  onClick?: () => undefined;
}

export const OptionItem: React.FC<OptionItemProps> = ({ children, modifiers, onClick }) => (
  <button type="button" className={mapModifiers('a-option-item', modifiers)} onClick={onClick}>
    {children}
  </button>
);
